import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaCartPlus, FaTrashAlt } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { getAmazonAffiliateLink, formatPrice, shortenArabicName, capitalizeFirstLetterOfEachWordAndShorten, handleProductClickAmazon } from '../utils';
import { useCart } from '../context/CartContext'; // adjust path if needed
import Header from './Header';
import Footer from './Footer';
import Searchbar from './Searchbar';
import BackButton from './BackButton';
import { Helmet } from 'react-helmet';
import SexyCategoryBar from './SexyCategoryBar';
// import ShareCartButton from './ShareCartButton';

export default function CartPage() {
  const { t, i18n } = useTranslation();
  const { cartItems, setCartItems, removeFromCart, getTotal, updateCartItemQuantity, replaceCartItems } = useCart();

  const handleQuantityChange = (itemId, newQuantity) => {
    if (newQuantity < 1) return; // optional, prevent quantity going to zero
    updateCartItemQuantity(itemId, newQuantity);
  };


  useEffect(() => {
  const fetchUpdatedCartItems = async () => {
    try {
      const ids = cartItems.map(item => item._id);
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/product/items/prices`, { ids });

      const updatedItems = res.data;

      // Merge updated prices with local cart quantities
      const mergedCart = cartItems.map(localItem => {
        const updated = updatedItems.find(i => i._id === localItem._id);
        return updated ? { ...updated, quantity: localItem.quantity } : localItem;
      });

      replaceCartItems(mergedCart); // Update context + localStorage
    } catch (err) {
      console.error('Failed to fetch updated cart prices:', err);
    }
  };

  if (cartItems.length > 0) {
    fetchUpdatedCartItems();
  }
}, []); // Only on mount


  // useEffect(() => {
  //   // Check if the 'sharedCart' parameter is present in the URL
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const sharedCart = urlParams.get('sharedCart');

  //   if (sharedCart) {
  //     // Decode and parse the shared cart data from the URL
  //     try {
  //       const decodedCartData = decodeURIComponent(sharedCart);
  //       const parsedCart = JSON.parse(decodedCartData);

  //       // Update cartItems in context
  //       setCartItems(parsedCart);

  //       // Optionally store it in localStorage as well
  //       localStorage.setItem('cart', JSON.stringify(parsedCart));

  //       alert('Cart has been loaded from the shared link!');
  //     } catch (error) {
  //       console.error('Error parsing shared cart data:', error);
  //     }
  //   }
  // }, [setCartItems]);

  
  
  const recordUserClick = async (item, type) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/main/user/click`, {
        itemId: item._id,
        type,
        name: item.name,
        arabicName: item.arabicName,
        link: item.link,
        store: item.store,
        lang: i18n.language
      });
    } catch (err) {
      console.error('Failed to record click:', err);
    }
  };

  return (
<div className='container'>
<Helmet>
  <title>Cart - bkamho</title>
  <meta name="robots" content="noindex, nofollow" />
</Helmet>

<div className="max-w-6xl mx-auto p-4 bg-white">
    <div className='header-menu-container'>
    <Header />
    </div>
    <SexyCategoryBar />
    <Searchbar 
placeholder={t('searchbar.landingPage')} 
onSearchSubmit={(value) => {
        // handle the actual search logic here
    console.log('User searched:', value);
        // maybe call your API or filter state, etc.
    }}
/>
<div className="w-full flex justify-center mt-8">
  <div className="w-full max-w-md space-y-6">

    {/* <ShareCartButton /> */}
    
    {/* Cart Header */}
    <div className="text-center">
      <h1 className="text-xl pt-4 font-semibold text-[rgb(62,43,205)]">🛒 {t('Your Cart')}</h1>
      <p className="text-md text-left pb-4 pl-[5%] pr-[5%] text-gray-600">{t('Items you\'ve added to your cart can be found here, check them out in store!')}</p>
    </div>

    {/* Cart Items */}
    <div className="space-y-4">
    {cartItems.map((item) => (
  <div
    key={item._id}
    className="flex items-center bg-gray-50 p-3 rounded-md shadow-sm border-b border-gray-200 hover:bg-gray-100 relative"
  >
    {/* Product Image */}
    <Link
      to={`/product-page/${item._id}`}
      onClick={() => recordUserClick(item, "cartProductBox")}
      className="flex-shrink-0"
    >
      <img
        src={item.image}
        alt={item.name}
        className="w-16 h-16 object-contain rounded-md"
        onError={(e) => (e.target.src = '/logo2.png')}
        onClick={() => handleProductClickAmazon(item)}
      />
    </Link>

    {/* Product Info */}
    <div className="ml-3 flex-1">
      <h2 className="text-xs font-semibold text-gray-800 leading-snug break-words">
        {i18n.language === 'ar' && item.arabicName
          ? shortenArabicName(item.arabicName)
          : capitalizeFirstLetterOfEachWordAndShorten(item.name)}
      </h2>

      {/* Quantity Controls */}
      <div className="flex items-center mt-2 space-x-2">
  <button 
    className="btn btn-xs bg-gray-300 hover:bg-gray-400" 
    onClick={() => handleQuantityChange(item._id, item.quantity - 1)}
    disabled={item.quantity === 1}
  >
    -
  </button>
  <span className="w-8 text-center">{item.quantity}</span>
  <button 
    className="btn btn-xs bg-gray-300 hover:bg-gray-400" 
    onClick={() => handleQuantityChange(item._id, item.quantity + 1)}
  >
    +
  </button>
</div>


      {/* Price */}
      <div className="mt-2">
        {item.prices.discounted && item.prices.discounted !== item.prices.original ? (
          <div className="flex items-center space-x-1">
            <span className="text-primary font-bold text-xs">
              {/* {`${t('priceBox.now')} ${formatPrice(item.prices.discounted)} ${item.currency}`} */}
              {`${t('priceBox.now')} ${formatPrice((parseFloat(item.prices.discounted)) * item.quantity)} ${item.currency}`}
            </span>
            <span className="line-through text-[10px] text-gray-400">
              {formatPrice(item.prices.original)} {item.currency}
            </span>
            {item.discountPercentage && (
              <div className="badge badge-error badge-xs">
                {item.discountPercentage}% OFF
              </div>
            )}
          </div>
        ) : (
          <span className="text-primary font-bold text-xs">
            {/* {`${t('priceBox.now')} ${formatPrice(item.prices.discounted || item.prices.original)} ${item.currency}`} */}
            {`${t('priceBox.now')} ${formatPrice((parseFloat(item.prices.discounted || item.prices.original)) * item.quantity)} ${item.currency}`}
          </span>
        )}
      </div>

      {/* View in Store Button */}
      <button
        onClick={async (e) => {
          e.stopPropagation();
          e.preventDefault();
          const link = await getAmazonAffiliateLink(item.link, item.store);
          if (link) {
            const newWindow = window.open(link, "_blank");
            if (newWindow) {
              await recordUserClick(item, "cartBuyFromStore");
            }
          }
        }}
        className="btn btn-xs bg-[#FF9900] text-white hover:bg-[rgb(62,43,205)] w-full mt-2"
      >
        {`Buy from ${item.store}`}
      </button>
    </div>

    {/* Trash Icon */}
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        removeFromCart(item._id);
        toast.success(t('Removed from cart'));
      }}
      className="absolute top-2 right-2 text-red-400 hover:text-red-600 cursor-pointer text-sm"
    >
      <FaTrashAlt className='text-red-500 hover:text-red-700' />
    </div>
  </div>
))}
    </div>

    {/* Cart Footer */}
    <div className="text-center mt-6 border-t pt-4">
      {/* <p className="text-sm font-semibold text-gray-700 dark:text-white"> */}
      <p className='text-[rgb(62,43,205)] font-semibold text-lg'>
        {t('Estimated Total:  ')}    
        <span className='text-gray-600'>{formatPrice(getTotal())} {cartItems[0]?.currency || 'SAR'}</span>
      </p>
    </div>

  </div>

</div>
<Footer />
</div>

</div>

  
  );
}